import type { Review, Service } from '../api/client'

// The Settings header's badges: her rating (counted as the Reviews panel
// counts it, visible rated reviews from clients) and the size of her menu.
// A badge with nothing to say is left out, so a new account shows none.
export function menuBadges(reviews: Review[], services: Service[]): string[] {
  const badges: string[] = []
  const rated = reviews.filter((r) => r.source === 'harmovi' && !r.hidden_reason && r.rating)
  if (rated.length > 0) {
    const avg = rated.reduce((n, r) => n + (r.rating ?? 0), 0) / rated.length
    badges.push(`${avg.toFixed(1)} from ${rated.length} review${rated.length === 1 ? '' : 's'}`)
  }
  if (services.length > 0) badges.push(`${services.length} treatment${services.length === 1 ? '' : 's'}`)
  return badges
}
